import { render, staticRenderFns } from "./AddEditRTReportWelder.vue?vue&type=template&id=162f07f4"
import script from "./AddEditRTReportWelder.vue?vue&type=script&lang=js"
export * from "./AddEditRTReportWelder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports